const regulationTheScene = () => import('../../pages/regulationTheScene.vue')
const regulationList = () => import('../../pages/regulationTheScene/regulationList.vue')
const particularsOlds = () => import('../../pages/regulationTheScene/particulars.vue')//旧的监理现场详情
const particulars = () => import('../../pages/regulationTheScene/particularsNews.vue')//2021-8-2修改完成的监理现场详情
const long = () => import('../../pages/regulationTheScene/long.vue')
const comparison = () => import('../../pages/regulationTheScene/comparison.vue')
const comparisonNew = () => import('../../pages/regulationTheScene/comparisonNew.vue')
const viewStandardDetails = () => import('../../pages/regulationTheScene/viewStandardDetails.vue')
const sceneTrafficLights = () => import('../../pages/regulationTheScene/sceneTrafficLights.vue')
const ConstructionPlan = () => import('@/pages/personalCenter/supervisePage/constructionPlan.vue')
const constructionPlanNotice = () => import('@/pages/personalCenter/supervisePage/constructionPlanNotice.vue')
const historyNotice = () => import('@/pages/personalCenter/supervisePage/historyNotice.vue')
const constructionYPlan = () => import('@/pages/personalCenter/supervisePage/constructionYPlan.vue')
const editPlan = () => import('@/pages/personalCenter/supervisePage/editPlan.vue')
const originalDrawing = () => import('@/pages/regulationTheScene/originalDrawing.vue')
const acceptance = () => import('@/pages/regulationTheScene/acceptance.vue')
export default [
  {
    path: '/regulationTheScene',
    name: '监理现场',
    component: regulationTheScene,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      backTopShow: true
    },
    // children: [
    //   {
    //     path: 'regulationList',
    //     name: 'regulationList',
    //     component: regulationList,
    //     meta: {
    //       headerShow: true,
    //       footerShow: true,
    //       sidebarShow: false,
    //     }
    //   }
    // ]
  },
  {
    path: '/regulationTheScene/particulars/:siteId',
    name: 'particulars',
    component: particulars,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      backTopShow: true
    }
  },
  {
    path: '/regulationTheScene/long/:siteId',
    name: 'long',
    component: long,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      backTopShow: true
    }
  },
  {
    path: '/regulationTheScene/comparison',
    name: 'comparison',
    component: comparison,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/regulationTheScene/comparisonNew',
    name: '整改对比',
    component: comparisonNew,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/regulationTheScene/viewStandardDetails',
    name: '标准详情',
    component: viewStandardDetails,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      backTopShow: true//返回到顶部
    }
  },
  {
    path: '/regulationTheScene/sceneTrafficLights',
    name: 'sceneTrafficLights',
    component: sceneTrafficLights,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      backTopShow: true
    }
  },
  {
    path: '/regulationTheScene/constructionPlan',
    name: '施工计划表',
    component: ConstructionPlan,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/regulationTheScene/constructionPlanNotice',
    name: '发送通知',
    component: constructionPlanNotice,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/regulationTheScene/historyNotice',
    name: '历史消息',
    component: historyNotice,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/regulationTheScene/constructionYPlan',
    name: '原计划表',
    component: constructionYPlan,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/regulationTheScene/editPlan',
    name: '编辑计划',
    component: editPlan,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/regulationTheScene/originalDrawing',
    name: '查看原图纸',
    component: originalDrawing,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },
  {
    path: '/regulationTheScene/acceptance',
    name: '查看验收项',
    component: acceptance,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
      keepAlive: false
    }
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/regulationTheSceneRouter.js